import {
  aiAnalyzedFileSchema,
  AiAnalyzedFileSource,
} from "@redotech/redo-model/ai-analyzed-file";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const paginateAiAnalyzedFiles = {
  name: "paginateAiAnalyzedFiles" as const,
  input: z.object({
    source: z.nativeEnum(AiAnalyzedFileSource).optional(),
    limit: z.number().positive().optional(),
    lastId: zExt.objectId().optional(),
    searchText: z.string().optional(),
  }),
  output: z.object({
    data: z.array(aiAnalyzedFileSchema),
    paginationKey: z.string().optional(),
  }),
};
